import { render, staticRenderFns } from "./ModalSelecaoCidades.vue?vue&type=template&id=71cfedaf&scoped=true"
import script from "./ModalSelecaoCidades.vue?vue&type=script&lang=js"
export * from "./ModalSelecaoCidades.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecaoCidades.vue?vue&type=style&index=0&id=71cfedaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cfedaf",
  null
  
)

export default component.exports